export const MODE = "dev";

export const URL_TOUR = "/api/v1/tour";
export const URL_REGISTER = "/api/v1/register";
export const URL_FORGOT_PASSWORD = "/api/v1/forgot-password";
export const URL_RESET = "/api/v1/reset-password";

